import type { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import * as reportApi from '@/services/reportService';

import * as userActions from '../user/userActions';

import * as actions from './reportActions';
import type { Report, ReportAction, ReportUserPeriod } from './reportTypes';

export function* addReportSaga({ payload }: ReportAction): SagaIterator {
	try {
		const businessesAnalyzed =
			(payload as Report)?.businessIds ??
			(localStorage.getItem('businesses_analyzed')
				? JSON.parse(
						localStorage.getItem('businesses_analyzed') as string
					)
				: '');

		if (businessesAnalyzed) {
			localStorage.removeItem('businesses_analyzed');

			yield call(
				reportApi.addReport,
				(payload as Report)?.type,
				businessesAnalyzed
			);
		}

		yield put(actions.reportAddSuccess());
	} catch (error) {
		yield put(actions.reportAddFailure(error));
	}
}

export function* getReportsSaga({ payload }: ReportAction): SagaIterator {
	try {
		const response = yield call(
			reportApi.getReports,
			(payload as ReportUserPeriod).startDate,
			(payload as ReportUserPeriod).endDate,
			(payload as ReportUserPeriod).userEmail,
			(payload as ReportUserPeriod).listId,
			(payload as ReportUserPeriod).method,
			(payload as ReportUserPeriod).locationId
		);

		if (response.status !== 200) {
			yield put(actions.reportGetReportsFailure());
			return;
		}

		yield put(actions.reportGetReportsSuccess(response.data.data));
	} catch (error) {
		yield put(actions.reportGetReportsFailure());
	}
}
